// KG: wishlist hearts on collection product cards
(function () {
  var BTN = '[data-kg-wishlist-btn]';

  // ── SDK helpers ──────────────────────────────────────────────────────────

  function getHash() {
    var sdk = window.WishListHero_SDK;
    if (!sdk || typeof sdk.GetWishListHash !== 'function') return Promise.resolve(null);
    return Promise.resolve(sdk.GetWishListHash(true)).catch(function () { return null; });
  }

  // ── Sync filled/outline state from the server list ───────────────────────

  function syncHearts() {
    var sdk = window.WishListHero_SDK;
    if (!sdk || typeof sdk.GetWishListItems !== 'function') return;
    Promise.resolve(sdk.GetWishListItems()).then(function (items) {
      if (!Array.isArray(items)) return;
      var saved = new Set(items.map(function (i) { return String(i.ProductVariantId); }));
      document.querySelectorAll(BTN).forEach(function (btn) {
        var wishlisted = saved.has(btn.dataset.variantId);
        btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
        btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }).catch(function () {});
  }

  // ── Click handler (capture phase — fires before card link's bubble handler) ──

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(BTN);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var sdk = window.WishListHero_SDK;
    if (!sdk) return;

    var productId   = parseInt(btn.dataset.productId, 10);
    var variantId   = parseInt(btn.dataset.variantId, 10);
    var handle      = btn.dataset.productHandle || '';
    var title       = btn.dataset.productTitle || '';
    var price       = parseInt(btn.dataset.productPrice || '0', 10) / 100;
    var imgSrc      = (btn.dataset.productImage || '').replace(/^https?:/, '');
    var link        = 'https://thebetterdiamonds.com/products/' + handle + '?variant=' + variantId;
    var isWishlisted = btn.getAttribute('aria-pressed') === 'true';

    getHash().then(function (hash) {
      if (!hash) return;
      if (isWishlisted) {
        return Promise.resolve(sdk.DeleteWishListItem({ ProductVariantId: variantId, WishlistHash: hash }))
          .then(function () {
            btn.setAttribute('aria-pressed', 'false');
            btn.setAttribute('aria-label', 'Add to wishlist');
            document.dispatchEvent(new CustomEvent('kg-wishlist-changed'));
          });
      } else {
        return Promise.resolve(sdk.AddWishListItem({
          ProductId: productId,
          ProductVariantId: variantId,
          ProductTitle: title,
          ProductPrice: price,
          ProductImage: imgSrc,
          ProductLink: link,
          WishlistHash: hash
        })).then(function () {
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', 'Remove from wishlist');
          document.dispatchEvent(new CustomEvent('kg-wishlist-changed'));
        });
      }
    }).catch(function (err) { console.warn('WishListHero SDK error:', err); });
  }, { capture: true });

  // ── Sync on SDK events and after header count changes ────────────────────

  ['wishlist-hero-wishlist-sdk-ready', 'wishlist-hero-wishlist-updated', 'kg-wishlist-changed'].forEach(function (evt) {
    document.addEventListener(evt, syncHearts);
    window.addEventListener(evt, syncHearts);
  });

  // ── Retry until SDK is ready (can load after this script) ────────────────

  var retryInterval = setInterval(function () {
    if (window.WishListHero_SDK && typeof window.WishListHero_SDK.GetWishListItems === 'function') {
      clearInterval(retryInterval);
      syncHearts();
    }
  }, 500);
  setTimeout(function () { clearInterval(retryInterval); }, 15000);

  // ── Re-sync after filtering/sorting/load-more re-renders the grid ────────
  // Watch for new [data-kg-wishlist-btn] nodes added to the DOM

  var mutationTimer;
  var observer = new MutationObserver(function (mutations) {
    var hasNewBtns = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches(BTN) || node.querySelector(BTN));
      });
    });
    if (!hasNewBtns) return;
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(syncHearts, 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  syncHearts();
})();
